import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Tooltip,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Select,
  Space,
  Checkbox,
  Divider,
  Dropdown,
  Menu,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import {
  ExclamationCircleOutlined,
  UploadOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  UndoOutlined,
  ExportOutlined,
  DownOutlined,
  FilterFilled,
  WarningOutlined,
  DeleteOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

const { RangePicker } = DatePicker;
const { Option } = Select;
const Search = Input.Search;
// Uploads now go through the backend (POST /admin/media/upload), which
// holds the real AWS credentials server-side and never exposes them. This
// used to upload straight to S3 from the browser with a hardcoded access
// key + secret baked into this file — visible to anyone via view-source on
// the deployed site, no login required. See MediaUploadController.ts.

let baseURL = apiPath.brandManager;

// Live presence, derived server-side from lastActiveAt. "away" must not share a
// colour with "offline" — they mean different things to whoever reads the list.
const PRESENCE_COLORS = {
  online: "green",
  away: "orange",
  busy: "red",
  offline: "default",
};

// Generic single checkbox-list filter panel — replaces AntD's default
// `filters` dropdown UI, whose Reset button only clears the checkboxes
// without confirming (a follow-up OK click was needed to actually apply the
// reset — the exact "Reset does nothing" bug fixed the same way in Customer
// Management's User.js; same component, ported here). Reset here calls
// onApply([]) + close() together in one click.
function CheckboxFilterDropdown({ options, initial, onApply, onClose, width = 200, maxHeight }) {
  const [selected, setSelected] = useState(initial || []);
  return (
    <div style={{ padding: 12, width }}>
      <Checkbox.Group
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          ...(maxHeight ? { maxHeight, overflowY: "auto" } : {}),
        }}
        value={selected}
        onChange={setSelected}
        options={options}
      />
      <Divider style={{ margin: "10px 0" }} />
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Button
          size="small"
          type="link"
          onClick={() => {
            setSelected([]);
            onApply([]);
            onClose();
          }}
        >
          Reset
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            onApply(selected);
            onClose();
          }}
        >
          OK
        </Button>
      </Space>
    </div>
  );
}

function BrandManager() {
  // Align permission handling with TeamManager helper style
  const getPermissionByName = (moduleName) => {
    try {
      const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");
      if (user.type === "Admin") {
        return { view: true, add: true, edit: true, delete: true };
      }
      // Case/whitespace-insensitive match — see BlogTabs.js's identical fix.
      const normalizedTarget = String(moduleName || "").trim().toLowerCase();
      const permissions = user?.roleId?.permission || [];
      return (
        permissions.find(
          (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
        ) || {}
      );
    } catch {
      return {};
    }
  };
  const permissionObject = getPermissionByName("brandManager");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState({
    usertype: "",
  });
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  // Bulk-select (row checkboxes) so Admin can delete several staff accounts
  // in one action instead of one-by-one via the row's "..." menu.
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // Monthly Value is sensitive revenue data — masked by default, same
  // reveal-on-click convention as a password field, rather than sitting in
  // the clear on every page load.
  const [showMonthlyValue, setShowMonthlyValue] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [brandStrategists, setBrandStrategists] = useState([]);
  // One-time "Sync Customer Names" migration — self-hides once a run
  // reports nothing left to update (see handleMigrateCustomerNames). Plain
  // component state alone reset on every page load/remount, so confirming
  // "nothing left to sync" only lasted until the next refresh — persisted
  // to localStorage so it actually stays hidden once genuinely done.
  const [migratingCustomerNames, setMigratingCustomerNames] = useState(false);
  const [customerNamesSynced, setCustomerNamesSynced] = useState(
    () => localStorage.getItem("brandManagerCustomerNamesSynced") === "true"
  );

  // Column filter dropdown options for Name / Email / Customer Name(s) —
  // fetched once from every brand staff member (not just the loaded page),
  // same pattern as the Customer Management table.
  const [filterOptions, setFilterOptions] = useState({
    names: [],
    emails: [],
    customerNames: [],
  });

  // A plain "-" reads with the same visual weight as real data — a muted
  // dash recedes instead of competing for attention. Same convention as
  // Customer Management's User.js.
  const emptyCell = <span style={{ color: "#bbb" }}>—</span>;

  const columns = [
    {
      // Merged Profile + Name (same treatment as Customer Management's
      // Client column) — Profile carried no filter/sort of its own, so
      // folding it into one avatar+name cell loses zero functionality
      // while cutting a whitespace-only column. Pinned left so scrolling
      // right to see Presence/Clients/Monthly Value never loses track of
      // which staff member the row belongs to.
      title: "Staff",
      key: "name",
      fixed: "left",
      width: 200,
      // Server-side filter: dropdown options come from every brand staff
      // member (filterOptions.names, fetched from
      // /admin/brand-manager/filter-options), selected values sent to the
      // backend as `nameFilter` — filters the whole list, not just the page.
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.name?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.names.map((name) => ({ label: name, value: name }))}
          initial={rowFilter.name || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, name: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) =>
        String(a.name || a.userName || "").localeCompare(
          String(b.name || b.userName || "")
        ),
      render: (_, { name, userName, image }) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {image ? (
            <Image
              src={image}
              alt="Profile"
              style={{ width: 28, height: 28, borderRadius: 8, objectFit: "cover", flexShrink: 0 }}
            />
          ) : (
            <div className="main-new-class-image-no" style={{ width: 28, height: 28, flexShrink: 0 }}>
              <img src={Noimage} alt="" style={{ width: "100%", height: "100%" }} />
            </div>
          )}
          <span style={{ fontWeight: 600 }}>{name ? name : userName}</span>
        </div>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.email?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.emails.map((email) => ({ label: email, value: email }))}
          initial={rowFilter.email || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, email: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) => String(a.email || "").localeCompare(String(b.email || "")),
    },
    {
      // Client-side filter (fixed, small option set — same pattern as
      // Presence below) against whatever page of data is already loaded.
      title: "User Type",
      dataIndex: "type",
      key: "type",
      filteredValue: rowFilter.type || null,
      onFilter: (value, record) =>
        Array.isArray(record.type) ? record.type.includes(value) : record.type === value,
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.type?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={[
            { label: "Brand Manager", value: "Brand Manager" },
            { label: "Brand Strategist", value: "Brand Strategist" },
            { label: "Brand Head", value: "Brand Head" },
            { label: "Client Services", value: "Client Services" },
            { label: "Graphics Team Member", value: "Graphics Team Member" },
            { label: "Blog Writer", value: "Blog Writer" },
          ]}
          initial={rowFilter.type || []}
          onApply={(vals) => setRowFilter((prev) => ({ ...prev, type: vals }))}
          onClose={close}
        />
      ),
      render: (types) => Array.isArray(types) ? types.join(", ") : types
    },

    {
      title: "Customer Name(s)",
      key: "customers",
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.customers?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.customerNames.map((name) => ({ label: name, value: name }))}
          initial={rowFilter.customers || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, customers: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      render: (_, { relatedUsers }) => {
        if (!Array.isArray(relatedUsers) || relatedUsers.length === 0)
          return emptyCell;

        return (
          <div>
            {relatedUsers.map((cust, index) => (
              <div key={index}>{cust?.name || cust}</div>
            ))}
          </div>
        );
      },
    },
    {
      // Active/Inactive follows the same 14-day-activity rule used
      // everywhere else in the app (Customer Management list, etc.) —
      // Paused takes priority over activity, since a paused client can't
      // even log in. Computed server-side in BrandManagerController.list().
      title: "Clients",
      key: "clientStats",
      width: 150,
      sorter: (a, b) => (a.clientStats?.total || 0) - (b.clientStats?.total || 0),
      render: (_, { clientStats }) => {
        if (!clientStats || !clientStats.total) return emptyCell;
        const pill = (label, value, color) => (
          <Tooltip key={label} title={`${label}: ${value}`}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                fontSize: 12,
                fontWeight: 600,
                color,
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: color,
                  flexShrink: 0,
                }}
              />
              {value}
            </span>
          </Tooltip>
        );
        return (
          <div style={{ display: "flex", gap: 10 }}>
            {pill("Active", clientStats.active, "#389e0d")}
            {pill("Inactive", clientStats.inactive, "#cf1322")}
            {pill("Paused", clientStats.paused, "#d46b08")}
          </div>
        );
      },
    },
    {
      // Sum of each assigned client's currently-paid contract, normalized to
      // a monthly figure regardless of that contract's own payment cadence
      // (Quarterly/06-monthly/Upfront all get converted to a per-month
      // equivalent) — see ContractValueHelper.monthlyValueForContract.
      title: (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          Monthly Value
          <span
            role="button"
            title={showMonthlyValue ? "Hide monthly value" : "Show monthly value"}
            onClick={(e) => {
              e.stopPropagation();
              setShowMonthlyValue((prev) => !prev);
            }}
            style={{ cursor: "pointer", display: "inline-flex" }}
          >
            {showMonthlyValue ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </span>
        </span>
      ),
      key: "totalMonthlyValue",
      width: 120,
      sorter: (a, b) => (a.totalMonthlyValue || 0) - (b.totalMonthlyValue || 0),
      render: (_, { totalMonthlyValue }) => {
        if (!showMonthlyValue) {
          return <span style={{ color: "#bbb", letterSpacing: 2 }}>••••••</span>;
        }
        return totalMonthlyValue ? (
          <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
            $
            {totalMonthlyValue.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            })}
          </span>
        ) : (
          emptyCell
        );
      },
    },
    {
      // Live presence, derived server-side from lastActiveAt. Distinct from
      // the Activity Status-equivalent columns elsewhere, which are the
      // Active/Inactive account toggle. Moved to sit beside Last Login —
      // they're the same underlying signal (recent activity) told two ways,
      // so reading them side by side is more useful than having Presence
      // sit apart from the timestamp that explains it. This filter is
      // client-side only (no backend param) — custom dropdown for the same
      // one-click-Reset fix as everything else here.
      title: "PRESENCE",
      dataIndex: "currentStatus",
      key: "currentStatus",
      width: 110,
      filteredValue: rowFilter.currentStatus || null,
      onFilter: (value, record) => (record.currentStatus || "offline") === value,
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.currentStatus?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={[
            { label: "Online", value: "online" },
            { label: "Away", value: "away" },
            { label: "Busy", value: "busy" },
            { label: "Offline", value: "offline" },
          ]}
          initial={rowFilter.currentStatus || []}
          onApply={(vals) => setRowFilter((prev) => ({ ...prev, currentStatus: vals }))}
          onClose={close}
        />
      ),
      render: (currentStatus) => (
        <Tag color={PRESENCE_COLORS[currentStatus] || PRESENCE_COLORS.offline}>
          {currentStatus
            ? currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)
            : "Offline"}
        </Tag>
      ),
    },
    {
      title: "Last Login",
      key: "lastLogin",
      dataIndex: "lastLogin",
      width: 150,
      sorter: (a, b) =>
        new Date(a.lastLogin || 0).getTime() - new Date(b.lastLogin || 0).getTime(),
      // Full date + time, stacked and weighted for a quick scan (bold date,
      // lighter time underneath) rather than one flat "DD MMM YYYY, HH:mm"
      // string competing for attention all at the same weight. Relative
      // time ("2 hours ago") still available on hover for a quick sense of
      // recency without losing the actual timestamp.
      render: (_, { lastLogin }) => {
        if (!lastLogin) {
          return <span style={{ color: "#bbb" }}>Never logged in</span>;
        }
        const m = moment(lastLogin);
        return (
          <Tooltip title={m.fromNow()}>
            <div style={{ lineHeight: 1.3, whiteSpace: "nowrap" }}>
              <div style={{ fontWeight: 600, color: "#334155", fontSize: 13 }}>
                {m.format("DD MMM YYYY")}
              </div>
              <div style={{ color: "#94a3b8", fontSize: 12 }}>{m.format("HH:mm")}</div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Registration Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        // Only Reset Password + Delete are uncommon enough to fold into
        // "..." — Edit stays a full inline button since it's the primary
        // action on this table (same consolidation pattern as Customer
        // Management's Action column).
        const moreMenu = (
          <Menu>
            {permissionObject.edit && (
              <Menu.Item
                key="reset-password"
                icon={<i className="fa fa-key"></i>}
                onClick={() => {
                  setSelected(record);
                  setProvideSession(true);
                }}
              >
                Reset Password
              </Menu.Item>
            )}
            {permissionObject.delete && (
              <Menu.Item
                key="delete"
                danger
                icon={<i className="fas fa-trash"></i>}
                onClick={() => showConfirm1(record)}
              >
                Delete User
              </Menu.Item>
            )}
          </Menu>
        );
        const hasMoreActions = permissionObject.edit || permissionObject.delete;
        return (
          <div className="cta_wrap">
            {permissionObject.edit && (
              <Button
                title="Edit"
                onClick={() => {
                  record?.image && setFile([record.image]);
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i className="fa fa-light fa-pen"></i>
              </Button>
            )}
            {hasMoreActions && (
              <Dropdown overlay={moreMenu} trigger={["click"]} placement="bottomRight">
                <Button title="More actions">
                  <i className="fa fa-ellipsis-h"></i>
                </Button>
              </Dropdown>
            )}
          </div>
        );
      },
    },
  ];

  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post(`${apiPath.baseURL}admin/media/upload`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return { Location: res.data?.data?.url };
  };

  const roleData = () => {
    request({
      url: `${baseURL}/roleData?status=active`,
      method: "get",
      onSuccess: (data) => {
        setRoleList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const customerData = () => {
    request({
      url: `${apiPath.baseURL}/team-manager/customer-list?status=active`,
      method: "get",
      onSuccess: (data) => {
        setCustomerList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const brandData = () => {
    request({
      url: `${baseURL}/brandManagerList`,
      method: "GET",
      onSuccess: (res) => {
        const allUsers = res.data.data || [];
        setBrandStrategists(
          allUsers.filter((u) => u.type === "Brand Strategist")
        );
      },
    });
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const handleMigrateCustomerNames = () => {
    setMigratingCustomerNames(true);
    request({
      url: `${baseURL}/migrate-customer-names`,
      method: "GET",
      onSuccess: (data) => {
        setMigratingCustomerNames(false);
        ShowToast(data.message || "Customer names synced successfully", Severty.SUCCESS);
        setRefresh((prev) => !prev);
        // Idempotent one-time migration (see BrandManagerController.
        // migrateCustomerNames) — nothing left to update means every brand
        // member already has the right customer names on file, so hide the
        // button rather than leaving a permanently-visible action with
        // nothing left to do. Persisted so a refresh/remount doesn't bring
        // it back.
        if (!data?.data?.customersWithAssignments) {
          setCustomerNamesSynced(true);
          localStorage.setItem("brandManagerCustomerNamesSynced", "true");
        }
      },
      onError: (err) => {
        setMigratingCustomerNames(false);
        ShowToast(err?.response?.data?.message || "Migration failed", Severty.ERROR);
      },
    });
  };

  const handleExport = () => {
    const exportData = list.map((item) => ({
      Name: item.name,
      Email: item.email,
      "User Type": item?.type?.join(", ") || "N/A",
      "Customer Name(s)": item.relatedUsers.map((c) => c.name || c).join(", "),
      "Registration Date": new Date(item.created_at).toLocaleDateString(),
      Status: item.isActive ? "Active" : "Inactive",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, "Teams");
    const fileName = `Brand_${moment().format("YYYY-MM-DD")}.xlsx`;
    XLSX.writeFile(wb, fileName);
    ShowToast("Export completed successfully", Severty.SUCCESS);
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;
  useEffect(() => {
    if (!permissionObject?.view) {
      navigate("/dashboard");
    }
  }, [permissionObject?.view]);

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const deleteUser = (id) => {
    setLoading(true);
    request({
      url: `${baseURL}/delete-account/${id}`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false)
        console.log(error);
        ShowToast(error.response.data.message, Severty.ERROR);

      },
    });
  };

  // No bulk-delete endpoint on the backend, so several selected staff
  // accounts are deleted with one PUT each, in parallel — same
  // delete-account route the single-row flow uses, just fired N times.
  // Only one success/error toast + refresh for the whole batch, not one per
  // row, so deleting 5 accounts doesn't spam 5 toasts.
  const deleteUsers = (ids) => {
    setLoading(true);
    Promise.allSettled(
      ids.map(
        (id) =>
          new Promise((resolve, reject) => {
            request({
              url: `${baseURL}/delete-account/${id}`,
              method: "PUT",
              onSuccess: resolve,
              onError: reject,
            });
          })
      )
    ).then((results) => {
      setLoading(false);
      setRefresh((prev) => !prev);
      setSelectedRowKeys([]);
      const failed = results.filter((r) => r.status === "rejected").length;
      if (failed === 0) {
        ShowToast(`${ids.length} account(s) deleted successfully`, Severty.SUCCESS);
      } else {
        ShowToast(
          `Deleted ${ids.length - failed} of ${ids.length} account(s); ${failed} failed`,
          failed === ids.length ? Severty.ERROR : Severty.SUCCESS
        );
      }
    });
  };

  const showConfirm1 = (record) => {
    // Staff accounts have no contract of their own — the equivalent
    // "don't delete this without knowing what it affects" fact here is
    // whether this person still has active clients assigned to them (see
    // the Clients column's clientStats.active), same spirit as Customer
    // Management's contract-status warning on its own Delete Account modal.
    const activeClients = record.clientStats?.active || 0;
    setTimeout(() => {
      confirm({
        title: "Delete Account",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div className="delete-account-confirm-content">
            <p>
              Are you sure you want to delete <strong>{record.name || record.userName || "this account"}</strong>?
              This action cannot be undone.
            </p>
            {activeClients > 0 && (
              <div className="delete-account-confirm-warning">
                <WarningOutlined />
                <span>
                  This staff member has {activeClients} active client{activeClients === 1 ? "" : "s"} assigned.
                </span>
              </div>
            )}
          </div>
        ),
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        onOk() {
          deleteUser(record._id);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  // Same contract-status-warning spirit as showConfirm1, rolled up across
  // every selected row — names every selected account (so it's clear
  // exactly who's about to be deleted, not just a count) and warns once if
  // ANY of them still has active clients assigned, rather than repeating
  // the warning per row.
  const showBulkDeleteConfirm = () => {
    const selectedRecords = list.filter((item) => selectedRowKeys.includes(item._id));
    const staffWithActiveClients = selectedRecords.filter((r) => (r.clientStats?.active || 0) > 0);
    confirm({
      title: "Delete Accounts",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div className="delete-account-confirm-content">
          <p>
            Are you sure you want to delete these {selectedRecords.length} account
            {selectedRecords.length === 1 ? "" : "s"}?
          </p>
          <ul className="delete-account-confirm-list">
            {selectedRecords.map((r) => (
              <li key={r._id}>{r.name || r.userName || r.email}</li>
            ))}
          </ul>
          <p>This action cannot be undone.</p>
          {staffWithActiveClients.length > 0 && (
            <div className="delete-account-confirm-warning">
              <WarningOutlined />
              <span>
                {staffWithActiveClients.length} of these staff member{staffWithActiveClients.length === 1 ? "" : "s"}{" "}
                still {staffWithActiveClients.length === 1 ? "has" : "have"} active clients assigned.
              </span>
            </div>
          )}
        </div>
      ),
      okText: "Yes, Delete All",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteUsers(selectedRowKeys);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate, filter]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-user/${viewData._id}`);
  }, [visibleView]);

  // Column filter dropdown options — fetched once (and again on refresh) so
  // Name/Email/Customer Name(s) filters cover every brand staff member, not
  // just the currently loaded page.
  useEffect(() => {
    request({
      url: `${baseURL}/filter-options`,
      method: "GET",
      onSuccess: (data) => {
        const d = data?.data || {};
        setFilterOptions({
          names: d.names || [],
          emails: d.emails || [],
          customerNames: d.customerNames || [],
        });
      },
      onError: () => {},
    });
  }, [refresh]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const f = filters || rowFilter;
    const filterActive = f.isActive;
    const nameValues = Array.isArray(f.name) ? f.name : [];
    const emailValues = Array.isArray(f.email) ? f.email : [];
    const customerValues = Array.isArray(f.customers) ? f.customers : [];
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}&type=${filter.userType ? filter.userType : ""
        }&nameFilter=${nameValues.length ? nameValues.map(encodeURIComponent).join(",") : ""
        }&emailFilter=${emailValues.length ? emailValues.map(encodeURIComponent).join(",") : ""
        }&customerFilter=${customerValues.length ? customerValues.map(encodeURIComponent).join(",") : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeDate = (e) => {
    if (e && e.length > 0) {
      const start = moment(e[0]).format("YYYY-MM-DD");
      const end = moment(e[1]).format("YYYY-MM-DD");
      setPagination((prev) => ({ ...prev, current: 1 }));
      setStartDate(start);

      setEndDate(end);
    } else {
      setStartDate("");
      setEndDate("");
      setPagination((prev) => ({ ...prev, current: 1 }));
    }
  };

  const handleSetRoleById = (id) => {
    const selectedRole = roleList.find((role) => role._id === id);
    if (selectedRole) {
      setFilter((prev) => ({
        ...prev,
        role: {
          label: selectedRole.name,
          value: selectedRole._id,
        },
      }));
    }
  };
  const rangeValue = startDate && endDate ? [startDate, endDate] : null;
  return (
    <>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              id="bm-staff-table-card"
              className="criclebox tablespace mb-24 customer-table bm-staff-table"
              title="Brand Manager and Strategist"
              extra={
                <Space wrap size={[10, 10]} align="center" className="gfx-toolbar">
                  <Search
                    size="large"
                    placeholder="Search by Name, Email, Number"
                    onChange={onSearch}
                    title="Search by Name, Email, Number"
                    value={searchText}
                    onPressEnter={onSearch}
                  />

                  <RangePicker
                    value={
                      startDate && endDate
                        ? [
                          moment(startDate, "YYYY-MM-DD"),
                          moment(endDate, "YYYY-MM-DD"),
                        ]
                        : null
                    }
                    onChange={handleChangeDate}
                  />

                  <Select
                    placeholder="Select a user type"
                    options={[
                      { label: "Brand Head", value: "Brand Head" },
                      { label: "Brand Strategist", value: "Brand Strategist" },
                      { label: "Brand Manager", value: "Brand Manager" },
                      { label: "Client Services", value: "Client Services" },
                    ]}
                    allowClear
                    value={filter?.userType} // controlled value
                    onChange={(selected) => {
                      setFilter((prev) => ({
                        ...prev,
                        userType: selected,
                      }));
                      setPagination((prev) => ({ ...prev, current: 1 }));
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />

                  {permissionObject.add && (
                    <Button
                      type="primary"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Staff
                    </Button>
                  )}
                  {/* Icon-only refresh — re-fetches this page's data in place
                      (setRefresh flips the useEffect dep below) instead of
                      making the user hard-reload the browser tab, per direct
                      request. Replaces the old text "Reset" button, which
                      cleared every filter/search/date too — this one only
                      refetches, it doesn't touch filter state. */}
                  <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    title="Refresh"
                    onClick={() => setRefresh((prev) => !prev)}
                  />
                  {!customerNamesSynced && (
                    <Button
                      type="primary"
                      loading={migratingCustomerNames}
                      onClick={handleMigrateCustomerNames}
                      title="One-time: fixes up customer names on brand staff records after a past sync issue"
                    >
                      Sync Customer Names
                    </Button>
                  )}
                  <Button
                    type="primary"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  {permissionObject.delete && selectedRowKeys.length > 0 && (
                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      onClick={showBulkDeleteConfirm}
                    >
                      Delete Selected ({selectedRowKeys.length})
                    </Button>
                  )}
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  rowKey="_id"
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                    // Default antd selection column is a full-width column of
                    // its own — reads as too much next to the Staff avatar
                    // it sits beside. Narrowed so it reads as a small
                    // checkbox tucked next to the avatar, not its own column.
                    columnWidth: 36,
                  }}
                  // Required for the Staff column's fixed:"left" to actually
                  // pin — AntD only activates sticky columns once it knows
                  // the table has real horizontal overflow to scroll within.
                  scroll={{ x: "max-content" }}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>
    </>
  );
}

const AddFrom = ({
  show,
  hide,
  data,
  refresh,
  handleChangeImage,
  file,
  setFile,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const [images, setImages] = useState();
  const [customerList, setCustomerList] = useState([]);
  const [userType, setUserType] = useState([]);
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const [brandStrategists, setBrandStrategists] = useState([]);
  const [brandHead, setBrandHead] = useState([]);
  const handleImage = (data) => {
    setImage(data?.[0]?.url || "");
    form.setFieldsValue({ image: data });
  };

  const customerData = () => {
    request({
      url: `${apiPath.baseURL}/admin/team-manager/customer-list?status=active`,
      method: "get",
      onSuccess: (data) => {
        setCustomerList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const brandList = () => {
    request({
      url: `${apiPath.customerManager}/brandManagerList`,
      method: "GET",
      onSuccess: (res) => {
        const allUsers = res.data.data || [];
  
        setBrandStrategists(
          allUsers.filter((u) =>
            Array.isArray(u.type) && u.type.includes("Brand Strategist")
          )
        );
  
        setBrandHead(
          allUsers.filter((u) =>
            Array.isArray(u.type) && u.type.includes("Brand Head")
          )
        );
      },
    });
  };

       useEffect(() => {
       customerData();
       brandList();
       if (!data) return;

       form.setFieldsValue({
         ...data,
         image: data?.image,
         profilePic: data?.profilePic,
         email: data?.email,
         name: data?.name,
         type: Array.isArray(data?.type) ? data.type : [data?.type].filter(Boolean),
         brandHead: data.brandHead?.[0], // Assuming it's an array
         customers: Array.isArray(data.customerId)
    ? data.customerId.map((id) => id.toString())
    : [],
         brandStrategist: Array.isArray(data.brandStrategist)
           ? data.brandStrategist.map((c) => c?._id?.toString() || c)
           : [],
       });

       setImage(data?.image);
       setImages(data?.images);
       setUserType(Array.isArray(data?.type) ? data.type : [data?.type].filter(Boolean));
     }, [data]);
     

  const onCreate = (values) => {
    const payload = {
      name: values.name,
      email: values.email,
      type: values.type, // Now an array
      image: image || "",
      customerId: values.customers,
      brandStrategist: values.brandStrategist,
      brandHead: values.brandHead,
    };

    const url = data
      ? `${baseURL}/edit-user/${data._id}`
      : `${baseURL}/add-user`;
    const method = data ? "PUT" : "POST";

    setLoading(true);
    request({
      url,
      method,
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
          setFile([]);
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        ShowToast(
          err.response?.data?.message || "Something went wrong",
          Severty.ERROR
        );
        setLoading(false);
      },
    });
  };

  const handleChangeData = (data) => {
    setUserType(data);
  };
  return (
    <Modal
      open={show}
      width={720}
      title={`${data
        ? "Edit Brand Manager and Strategist"
        : "Add New Brand Manager and Strategist"
        }`}
      okText="Submit"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={16}>
          <Col span={24} md={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please input the name!" },
                {
                  pattern: /^[a-zA-Z ]*$/,
                  message: "Only alphabetic characters allowed",
                },
                { max: 50, message: "Name cannot exceed 50 characters" },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Please input the email!" },
                { type: "email", message: "Invalid email format" },
                { max: 100, message: "Email cannot exceed 100 characters" },
              ]}
            >
              <Input placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              label="UserType"
              name="type"
              rules={[{ required: true, message: "Please select at least one type" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select Type"
                onChange={(e) => handleChangeData(e)}
              >
                <Select.Option value="Brand Manager">
                  Brand Manager
                </Select.Option>
                <Select.Option value="Brand Strategist">
                  Brand Strategist
                </Select.Option>
                <Select.Option value="Brand Head">Brand Head</Select.Option>
                <Select.Option value="Client Services">
                  Client Services
                </Select.Option>
                <Select.Option value="Graphics Team Member">
                  Graphics Team Member
                </Select.Option>
                <Select.Option value="Blog Writer">
                  Blog Writer
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {userType.includes("Brand Manager") ? (
            <Col span={24} md={12}>
              <Form.Item label="Brand Strategist" name="brandStrategist">
                <Select allowClear placeholder="Select Brand Strategist">
                  {brandStrategists.map((user) => (
                    <Option key={user._id} value={user._id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            ""
          )}
          {!userType.includes("Brand Head") ? (
            <Col span={24} md={12}>
              <Form.Item label="Brand Head" name="brandHead">
                <Select allowClear placeholder="Select Brand Head">
                  {brandHead.map((user) => (
                    <Option key={user._id} value={user._id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            ""
          )}

          <Col span={24} md={12}>
            <Form.Item
              label="Select Customers"
              name="customers"
              rules={[
                {
                  required: false,
                  message: "Please select at least one customer",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Customers"
                suffixIcon={<DownOutlined />}
                options={customerList.map((customer) => ({
                  label: customer.name,
                  value: customer._id.toString(),
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              name="image"
              label="Profile Image"
            // rules={[
            //   {
            //     validator: (_, value) =>
            //       image
            //         ? Promise.resolve()
            //         : Promise.reject(new Error("Image is required")),
            //   },
            // ]}
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType="Profile"
                btnName="Profile Image"
                onChange={handleImage}
                isDimension={false}
              />
            </Form.Item>
            <p className="img-size-details">
              **Images should be in .png, .jpg, or .jpeg format and under 5MB.**
            </p>
            {image && <Image width={120} src={image} />}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};




const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              placeholder="Enter a new password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  max: 100,
                  message: "Password cannot exceed 100 characters",
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
                },
              ]}
            >
              <Input.Password placeholder="Enter a new password" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              placeholder="Enter a confirm password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Confrim password do not match with New Password"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Enter a confirm password" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BrandManager;
